// extracted by mini-css-extract-plugin
export default {"contentBlock":"SortingSettingsPage_contentBlock__mt2u6","btnDisabled":"SortingSettingsPage_btnDisabled__aIJ+z"};